const autoNgTemplateLoaderTemplate1 = require('./code-editor.html');

import controller from './code-editor.controller';

angular.module('portainer.app').component('codeEditor', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    identifier: '@',
    textTip: '@',
    yml: '<',
    dockerFile: '<',
    shell: '<',
    readOnly: '<',
    onChange: '<',
    value: '<',
    height: '@',
    schema: '<',
  },
});
